import { api } from '../../lib/api';
import { putToStorage } from '../../lib/storage';

export const ATTACHMENT_TYPES = [
  { value: 'Quote', label: 'Quote' },
  { value: 'Spec', label: 'Spec' },
  { value: 'Photo', label: 'Photo' },
  { value: 'Invoice', label: 'Invoice' },
  { value: 'Other', label: 'Other' },
];

export const attachmentTypeLabel = (value) =>
  ATTACHMENT_TYPES.find((t) => t.value === value)?.label || value;

/**
 * Builds an attachments client bound to a parent resource path, e.g.
 * `/requisitions/{id}/attachments` or `/purchase-orders/{id}/attachments`.
 * Mirrors the supplier-document 3-step S3 upload/open flow.
 */
export function makeAttachmentsApi(basePath) {
  return {
    list: () => api.get(basePath),

    upload: async (file, meta = {}) => {
      const contentType = file.type || 'application/octet-stream';
      const ticket = await api.post(`${basePath}/upload-url`, {
        fileName: file.name,
        contentType,
        sizeBytes: file.size,
      });

      await putToStorage(ticket.uploadUrl, file, contentType);

      return api.post(basePath, {
        attachmentId: ticket.attachmentId,
        storageKey: ticket.storageKey,
        fileName: file.name,
        contentType: file.type || null,
        sizeBytes: file.size,
        attachmentType: meta.attachmentType || 'Other',
        description: meta.description || null,
        lineId: meta.lineId || null,
      });
    },

    open: async (attachmentId) => {
      const res = await api.get(`${basePath}/${attachmentId}/download-url`);
      if (res?.url) window.open(res.url, '_blank', 'noopener');
      return res;
    },

    /** Presigned GET URL without opening a window (e.g. for inline thumbnails). */
    downloadUrl: (attachmentId) => api.get(`${basePath}/${attachmentId}/download-url`),

    remove: (attachmentId) => api.del(`${basePath}/${attachmentId}`),
  };
}
